var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 58 59",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    id: "fi_3815602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "070---About-Us"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m39 23v6.51c-5.8453248-4.6800053-14.1546752-4.6800053-20 0v-6.51c0-3.8659932 3.1340068-7 7-7h6c3.8659932 0 7 3.1340068 7 7z",
    fill: "#945ba4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 29,
    cy: 8,
    fill: "#fcd6ac",
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m19 24.4v5.11c-1.1415867.9130624-2.1511826 1.9798688-3 3.17-.716818.9895696-1.3142874 2.0603152-1.78 3.19-.8113655 1.9415365-1.2261695 4.0257567-1.22 6.13 0 .34.01.67.03 1h-7.03c-2.20685824-.0054966-3.99450344-1.7931418-4-4v-.05c-1.16416564-.2376343-2.0002425-1.2618285-2-2.45v-8.5c0-3.8659932 3.13400675-7 7-7h6c2.4594724-.0034207 4.7390677 1.2883499 6 3.4z",
    fill: "#ff5364"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 13,
    fill: "#fcd6ac",
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m58 28v8.5c.0002425 1.1881715-.8358344 2.2123657-2 2.45v.05c-.0054966 2.2068582-1.7931418 3.9945034-4 4h-7.03c.02-.33.03-.66.03-1 .0061695-2.1042433-.4086345-4.1884635-1.22-6.13-.4657126-1.1296848-1.063182-2.2004304-1.78-3.19-.8514759-1.1879402-1.8607473-2.2544037-3-3.17v-5.11c1.2609323-2.1116501 3.5405276-3.4034207 6-3.4h6c3.8659932 0 7 3.1340068 7 7z",
    fill: "#f2d45b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 48,
    cy: 13,
    fill: "#fcd6ac",
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m24 28.8c-.5522847 0-1-.4477153-1-1v-3.8c0-.5522847.4477153-1 1-1s1 .4477153 1 1v3.8c0 .5522847-.4477153 1-1 1z",
    fill: "#884b9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m34 28.8c-.5522847 0-1-.4477153-1-1v-3.8c0-.5522847.4477153-1 1-1s1 .4477153 1 1v3.8c0 .5522847-.4477153 1-1 1z",
    fill: "#884b9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m6 29v8.5c-.00130583.9285034-.36766485 1.8192587-1.02 2.48-.6504323.643333-1.52522184 1.0090237-2.44 1.02-.35299065-.6074777-.53927268-1.2974112-.54-2v-.05c.06379104.0011838.12736062.0078754.19.02.49617575.0943982 1.00725274-.0585518 1.37-.41.28138497-.2810347.4396499-.6623093.44-1.06v-8.5c0-.5522847.44771525-1 1-1s1 .4477153 1 1z",
    fill: "#de4d60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m15 36.25c-.5522847 0-1-.4477153-1-1v-6.25c0-.5522847.4477153-1 1-1s1 .4477153 1 1v6.25c0 .5522847-.4477153 1-1 1z",
    fill: "#de4d60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m56 38.95v.05c-.0007273.7025888-.1870094 1.3925223-.54 2-1.9212692-.0126643-3.4694194-1.5787122-3.46-3.5v-8.5c0-.5522847.4477153-1 1-1s1 .4477153 1 1v8.5c.0003501.3976907.158615.7789653.44 1.06.36523.3471895.8740892.4994758 1.37.41.0627161-.0116027.1262426-.0182897.19-.02z",
    fill: "#efc319"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m43 36.25c-.5522847 0-1-.4477153-1-1v-6.25c0-.5522847.4477153-1 1-1s1 .4477153 1 1v6.25c0 .5522847-.4477153 1-1 1z",
    fill: "#efc319"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m45 42c0 .34-.01.67-.03 1-.5175943 8.440389-7.5137556 15.0206635-15.97 15.0206635s-15.4524057-6.5802745-15.97-15.0206635c-.02-.33-.03-.66-.03-1 0-8.836556 7.163444-16 16-16s16 7.163444 16 16z",
    fill: "#4481c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m29 59c-8.9724229-.0107461-16.396128-6.9838138-16.968-15.938-.021-.35-.032-.7-.032-1.062 0-9.3888407 7.6111593-17 17-17s17 7.6111593 17 17c0 .361-.011.712-.032 1.062-.571872 8.9541862-7.9955771 15.9272539-16.968 15.938zm0-32c-8.2842712 0-15 6.7157288-15 15 0 .318.009.628.028.938.4842143 7.9137178 7.0434823 14.0839127 14.972 14.0839127s14.4877857-6.1701949 14.972-14.0839127c.019-.31.028-.62.028-.938 0-8.2842712-6.7157288-15-15-15z",
    fill: "#ebeff0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 29,
    cy: 52,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m28.664 45.973c-.9852159-.1988312-1.6862852-1.0751679-1.664-2.08v-.984c.0350696-1.4368049 1.058585-2.6586342 2.467-2.945 1.5766084-.2484541 2.6826584-1.6878605 2.5167475-3.2752788-.1659109-1.5874184-1.5456892-2.7670154-3.139599-2.6840991-1.5939097.0829163-2.8438447 1.399313-2.8441485 2.9953779.0003173.587952-.25809 1.1462598-.7065298 1.526509-.4484397.3802492-1.0414788.5439152-1.6214702.447491-1.0302535-.2067163-1.7463816-1.1468486-1.672-2.195.1138352-3.573814 2.9027961-6.4873677 6.4682277-6.7571865 3.5654317-.2698188 6.7610933 2.1908407 7.4114582 5.7068228.650365 3.5159822-1.4536508 6.9569436-4.8796859 7.9803637v.291c.0004203.5894306-.2591868 1.1490322-.7094936 1.5293641s-1.0454533.5426604-1.6265064.4436359z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserQuestion);
export default __webpack_public_path__ + "static/media/user-question.6e0840cb4bad7394d56ec6132f5bc0c2.svg";
export { ForwardRef as ReactComponent };